import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Fragment, useMemo, useState } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { PermissionsModal } from './PermissionsModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PermissionsMessage = ({
  connectionType,
  homemade,
  neededScopeGroups,
  trackInteraction
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const {
    name
  } = useDetailsPageContext();
  const filteredScopeGroups = useMemo(() => {
    return neededScopeGroups && neededScopeGroups.filter(scope => {
      return scope.name !== 'oauth';
    });
  }, [neededScopeGroups]);
  const renderedPermissionsMessage = useMemo(() => {
    if (homemade && connectionType !== 'STANDARD') {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.requirementsCard.permissions.text.homemadeAppTooltip"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.requirementsCard.permissions.text.homemadeAppPermissions"
        })
      });
    } else if (!filteredScopeGroups.length) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.requirementsCard.permissions.text.noRequiredPermissions",
        options: {
          name
        }
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "detailsPage.requirementsCard.permissions.text.viewPermissions_jsx",
        elements: {
          Link
        },
        options: {
          onClick: () => {
            setModalOpen(true);
            trackInteraction('click required account permissions');
          }
        }
      });
    }
  }, [name, homemade, connectionType, filteredScopeGroups, trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderedPermissionsMessage, modalOpen && /*#__PURE__*/_jsx(PermissionsModal, {
      onClose: () => setModalOpen(false),
      scopeGroups: filteredScopeGroups
    })]
  });
};